<template>
  <div class="otp">
    <input
      v-for="(box, i) in boxes"
      v-bind:key="i"
      v-bind:ref="'box' + i"
      class="otp-cell"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      v-bind:value="boxes[i]"
      v-on:input="onInput(i, $event)"
      v-on:keydown="onKeydown(i, $event)"
      v-on:focus="onFocus($event)"
      v-on:paste="onPaste($event)">
  </div>
</template>

<script>
export default {
  name: 'comp-otp-input',
  props: {
    length: { type: Number, default: 6 },
    value: { type: String, default: '' }
  },
  data: function () {
    return {
      boxes: this.toBoxes(this.value)
    }
  },
  watch: {
    // Resync when the parent resets the value (e.g. clears on error/cancel).
    value: function (v) {
      if (v !== this.boxes.join('')) {
        this.boxes = this.toBoxes(v)
      }
    }
  },
  methods: {
    toBoxes: function (str) {
      let arr = []
      for (let i = 0; i < this.length; i++) {
        arr.push(str && str[i] ? str[i] : '')
      }
      return arr
    },
    focusBox: function (i) {
      let ref = this.$refs['box' + i]
      let el = Array.isArray(ref) ? ref[0] : ref
      if (el) {
        el.focus()
        el.select()
      }
    },
    emitValue: function () {
      let code = this.boxes.join('')
      this.$emit('input', code)
      if (code.length === this.length) {
        this.$emit('complete', code)
      }
    },
    onInput: function (i, e) {
      let digits = e.target.value.replace(/[^0-9]/g, '')
      let digit = digits ? digits[digits.length - 1] : ''
      this.$set(this.boxes, i, digit)
      e.target.value = digit
      if (digit && i < this.length - 1) this.focusBox(i + 1)
      this.emitValue()
    },
    onKeydown: function (i, e) {
      if (e.key === 'Backspace' && !this.boxes[i] && i > 0) {
        this.focusBox(i - 1)
      } else if (e.key === 'ArrowLeft' && i > 0) {
        e.preventDefault()
        this.focusBox(i - 1)
      } else if (e.key === 'ArrowRight' && i < this.length - 1) {
        e.preventDefault()
        this.focusBox(i + 1)
      }
    },
    onFocus: function (e) {
      e.target.select()
    },
    onPaste: function (e) {
      e.preventDefault()
      let clipboard = e.clipboardData || window.clipboardData
      let text = clipboard ? clipboard.getData('text') : ''
      let digits = (text || '').replace(/[^0-9]/g, '').slice(0, this.length)
      if (!digits) return
      let arr = this.toBoxes('')
      for (let j = 0; j < digits.length; j++) arr[j] = digits[j]
      this.boxes = arr
      let next = Math.min(digits.length, this.length - 1)
      this.$nextTick(() => this.focusBox(next))
      this.emitValue()
    }
  }
}
</script>

<style scoped>
.otp {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.otp-cell {
  width: 44px;
  height: 56px;
  margin-right: 8px;
  padding: 0;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: var(--gray-high);
  background-color: #fff;
  border: 1px solid var(--border);
  border-radius: 6px;
  caret-color: var(--primary);
  transition: border-color .15s, background-color .15s;
}
.otp-cell:last-child {
  margin-right: 0;
}
.otp-cell:focus {
  outline: none;
  border-color: var(--primary);
  background-color: var(--blue-gray-low);
}
@media only screen and (max-width: 360px) {
  .otp-cell {
    width: 38px;
    height: 48px;
    font-size: 20px;
    margin-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CompOtpInput.vue